// extracted by mini-css-extract-plugin
export default {"row":"NumerationScreen_row__oeo-7","alignCenter":"NumerationScreen_alignCenter__XDvGn"};